import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Outlook = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      id="outlook_group_20_"
      fill="hsl(from hsl(206 100% 42%) h s 22%)"
      d="M23.2,12.7c0-0.2-0.1-0.3-0.2-0.4h0l0,0l-7.8-4.6c0,0-0.1,0-0.1-0.1c-0.3-0.2-0.7-0.2-1,0
	c0,0-0.1,0-0.1,0.1l-7.8,4.6l0,0c-0.2,0.1-0.3,0.5-0.2,0.7c0,0.1,0.1,0.1,0.2,0.2l7.8,4.6c0,0,0.1,0,0.1,0.1c0.3,0.2,0.7,0.2,1,0
	c0,0,0.1,0,0.1-0.1l7.8-4.6C23.1,13,23.2,12.9,23.2,12.7z"
    />
    <path
      id="outlook_group_19_"
      fill="hsl(from hsl(206 100% 42%) h s 36%)"
      d="M7.1,9.6h5.1v4.7H7.1V9.6z M22.1,4.9V2.7c0-0.5-0.4-1-0.9-1H8c-0.5,0-1,0.5-0.9,1v2.1l7.8,2.1
	L22.1,4.9z"
    />
    <path
      id="outlook_group_18_"
      fill="hsl(from hsl(206 100% 42%) h s 42%)"
      d="M7,4.9h5.2v4.7H7V4.9z"
    />
    <path
      id="outlook_group_17_"
      fill="hsl(from hsl(206 100% 42%) h s 59%)"
      d="M17.4,4.9h-5.2v4.7l5.2,4.7h4.7V9.5L17.4,4.9z"
    />
    <path
      id="outlook_group_16_"
      fill="hsl(from hsl(206 100% 42%) h s 42%)"
      d="M12.2,9.5h5.2v4.7h-5.2V9.5z"
    />
    <path
      id="outlook_group_15_"
      fill="hsl(from hsl(206 100% 42%) h s 36%)"
      d="M12.2,14.2h5.2v4.7h-5.2V14.2z"
    />
    <path
      id="outlook_group_14_"
      fill="hsl(from hsl(206 100% 42%) h s 28%)"
      d="M7.1,14.3h5.1v4.2H7.1V14.3z"
    />
    <path
      id="outlook_group_13_"
      fill="hsl(from hsl(206 100% 42%) h s 41%)"
      d="M17.4,14.2h4.7v4.7h-4.7V14.2z"
    />
    <linearGradient
      id="outlook_group_22_"
      gradientUnits="userSpaceOnUse"
      x1="14.5812"
      y1="-1582.6604"
      x2="14.5812"
      y2="-1572.7518"
      gradientTransform="matrix(1 0 0 1 0 1595.3334)"
    >
      <stop offset="0" stopColor="hsl(from hsl(206 100% 42%) h s 58%)" />
      <stop offset="1" stopColor="hsl(from hsl(206 100% 42%) h s 54%)" />
    </linearGradient>
    <path
      id="outlook_group_12_"
      fill="url(#outlook_group_22_)"
      d="M22.9,13.1L22.9,13.1l-7.8,4.4c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.3,0.1-0.4,0.1l-0.4-0.2
	c0,0-0.1,0-0.1-0.1l-7.9-4.5h0L6,12.7v8.8c0,0.6,0.5,1.1,1.1,1.1h15.1c0,0,0,0,0,0c0.1,0,0.2,0,0.4-0.1c0.1,0,0.1,0,0.1-0.1
	c0,0,0.1-0.1,0.1-0.1c0.3-0.2,0.4-0.5,0.4-0.8v-8.8C23.2,12.8,23.1,13,22.9,13.1z"
    />
    <path
      id="outlook_group_11_"
      opacity="0.5"
      fill="hsl(from hsl(206 100% 42%) h s 22%)"
      d="M22.8,12.6v0.5l-8.1,5.6l-8.4-6c0,0,0,0,0,0l0,0l-0.8-0.5V12l0.3,0l0.7,0.4l0,0l0.1,0
	c0,0,7.9,4.5,7.9,4.5l0.3,0.2c0,0,0.1,0,0.1,0C14.8,17,22.7,12.6,22.8,12.6L22.8,12.6z"
    />
    <path
      id="outlook_group_10_"
      fill="hsl(from hsl(206 100% 42%) h s 50%)"
      d="M22.9,13.1L22.9,13.1l-7.8,4.4c0,0-0.1,0-0.1,0.1c-0.3,0.1-0.7,0.1-1,0c0,0-0.1,0-0.1-0.1
	l-7.8-4.4l0,0C6.1,13,6,12.8,6,12.7v8.8c0,0.6,0.5,1.1,1.1,1.1c0,0,0,0,0,0h15.1c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0v-8.8
	C23.2,12.8,23.1,13,22.9,13.1z"
    />
    <path
      id="outlook_group_9_"
      opacity="0.1"
      d="M15.3,17.4l-0.1,0.1c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.3,0.1-0.4,0.1l3,3.5l5.2,1.2
	c0.1-0.1,0.3-0.2,0.3-0.4L15.3,17.4z"
    />
    <path
      id="outlook_group_8_"
      opacity="5.000000e-02"
      d="M15.8,17.1l-0.6,0.4c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.3,0.1-0.4,0.1l1.4,3.8l6.7,0.9
	c0.3-0.2,0.4-0.5,0.4-0.8v-0.1L15.8,17.1z"
    />
    <path
      id="outlook_group_7_"
      fill="hsl(from hsl(206 100% 42%) h s 59%)"
      d="M7.1,22.6h15c0.2,0,0.5-0.1,0.6-0.2l-8.5-5c0,0-0.1,0-0.1-0.1l-7.9-4.5h0L6,12.7v8.8
	C6,22.1,6.5,22.6,7.1,22.6C7.1,22.6,7.1,22.6,7.1,22.6z"
    />
    <path
      id="outlook_group_6_"
      opacity="0.1"
      d="M13.3,6.8V18c0,0.4-0.2,0.7-0.6,0.9c-0.1,0-0.2,0.1-0.4,0.1H6V6.4h1V5.9h5.3
	C12.8,5.9,13.3,6.3,13.3,6.8z"
    />
    <path
      id="outlook_group_5_"
      opacity="0.2"
      d="M12.8,7.4v11.1c0,0.1,0,0.3-0.1,0.4c-0.1,0.4-0.5,0.6-0.9,0.6H6v-13h5.8c0.2,0,0.3,0,0.4,0.1
	C12.6,6.7,12.8,7,12.8,7.4z"
    />
    <path
      id="outlook_group_4_"
      opacity="0.2"
      d="M12.8,7.4v10.1c0,0.5-0.4,1-1,1H6v-12h5.8c0.2,0,0.3,0,0.4,0.1C12.6,6.7,12.8,7,12.8,7.4z"
    />
    <path
      id="outlook_group_2_"
      opacity="0.2"
      d="M12.2,7.4v10.1c0,0.5-0.4,1-1,1H6v-12h5.3C11.8,6.4,12.2,6.8,12.2,7.4
	C12.2,7.4,12.2,7.4,12.2,7.4z"
    />
    <linearGradient
      id="outlook_group_23_"
      gradientUnits="userSpaceOnUse"
      x1="2.7544"
      y1="-1589.6654"
      x2="10.2413"
      y2="-1576.6984"
      gradientTransform="matrix(1 0 0 1 0 1595.3334)"
    >
      <stop
        offset="4.306369e-03"
        stopColor="hsl(from hsl(206 100% 42%) h s 48%)"
      />
      <stop offset="0.5" stopColor="hsl(from hsl(206 100% 42%) h s 44%)" />
      <stop offset="1" stopColor="hsl(from hsl(206 100% 42%) h s 38%)" />
    </linearGradient>
    <path
      id="outlook_group_1_"
      fill="url(#outlook_group_23_)"
      d="M1.7,6.4h9.6c0.5,0,1,0.4,1,1v9.6c0,0.5-0.4,1-1,1H1.7c-0.5,0-1-0.4-1-1V7.4
	C0.8,6.8,1.2,6.4,1.7,6.4z"
    />
    <path
      id="outlook_group"
      fill="hsl(from hsl(206 100% 42%) h s 100%)"
      d="M3.7,10.4C4,9.9,4.4,9.5,4.8,9.2C5.4,8.9,6,8.8,6.6,8.8c0.6,0,1.1,0.1,1.6,0.4
	C8.6,9.5,9,9.9,9.2,10.3c0.3,0.5,0.4,1.1,0.4,1.7c0,0.6-0.1,1.2-0.4,1.8C9,14.3,8.6,14.7,8.1,15c-0.5,0.3-1.1,0.4-1.7,0.4
	c-0.6,0-1.1-0.1-1.6-0.4c-0.5-0.3-0.8-0.7-1.1-1.2c-0.3-0.5-0.4-1.1-0.4-1.7C3.4,11.6,3.5,11,3.7,10.4z M4.9,13.3
	C5,13.6,5.3,13.8,5.5,14c0.3,0.2,0.6,0.3,1,0.3c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.5,0.6-0.8c0.1-0.4,0.2-0.7,0.2-1.1
	c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.3-0.3-0.6-0.6-0.8c-0.3-0.2-0.7-0.3-1-0.3c-0.3,0-0.7,0.1-1,0.3C5.3,10.4,5,10.6,4.9,11
	C4.6,11.7,4.6,12.5,4.9,13.3L4.9,13.3z"
    />
    <path
      id="outlook_group_21_"
      fill="hsl(from hsl(206 100% 42%) h s 74%)"
      d="M17.4,4.9h4.7v4.7h-4.7V4.9z"
    />
  </svg>
);
